import { network } from 'services/network';
import { useMutation } from 'react-query';

const SetHomePage = (params) => {
    const url = `admin/bo/setHomePage?homePageURL=${params.urlPage}`;
    return network
        .post(url)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const useMutationSetHomePage = () => {
    return useMutation<unknown, QueryError, { urlPage: string }>((params: { urlPage: string }) => SetHomePage(params));
};

export { useMutationSetHomePage };
